/* Generated from lib/industryPacks/catalog.ts by `npm run packs:locale`. Edit the catalogue's English,
 * then regenerate; translations live in locales/<lang>/packs.ts with the same keys. */
export const packs = {
  "property": {
    "assetTypes": {
      "0": "House",
      "1": "Apartment",
      "2": "Office",
      "3": "Boiler",
      "4": "Electrical system",
      "5": "Fire equipment",
      "6": "Appliance"
    },
    "sample": {
      "name": "Sample property",
      "description": "An example property so you can try an inspection before adding your own."
    },
    "templates": {
      "condition_inspection": {
        "name": "Property condition inspection",
        "description": "Walk the property and record its condition room by room.",
        "items": {
          "0": {
            "label": "External condition and grounds"
          },
          "1": {
            "label": "Roof, gutters and rainwater goods"
          },
          "2": {
            "label": "Windows and external doors"
          },
          "3": {
            "label": "Damp, mould or water damage",
            "description": "Answer yes if any is present."
          },
          "4": {
            "label": "Heating and hot water working"
          },
          "5": {
            "label": "Internal condition overall"
          }
        }
      },
      "room_inspection": {
        "name": "Room inspection",
        "description": "A single room, in enough detail to settle a dispute later.",
        "groups": {
          "0": {
            "label": "Room condition",
            "guidance": "Scan the walls, ceiling, floor and windows. Show the smoke alarm if there is one."
          },
          "1": {
            "label": "Services and fittings"
          }
        },
        "items": {
          "0": {
            "label": "Walls and ceiling"
          },
          "1": {
            "label": "Floor covering"
          },
          "2": {
            "label": "Window and glazing"
          },
          "3": {
            "label": "Smoke alarm present"
          },
          "4": {
            "label": "Sockets, switches and lighting"
          },
          "5": {
            "label": "Fixtures and fittings"
          },
          "6": {
            "label": "Cleanliness"
          }
        }
      },
      "move_in_out": {
        "name": "Move-in / move-out",
        "description": "The record both sides agree to at handover.",
        "items": {
          "0": {
            "label": "Meter readings recorded"
          },
          "1": {
            "label": "Keys handed over and counted"
          },
          "2": {
            "label": "Smoke and CO alarms tested"
          },
          "3": {
            "label": "Overall cleanliness"
          },
          "4": {
            "label": "Existing damage photographed"
          },
          "5": {
            "label": "Appliances present and working"
          }
        }
      },
      "fire_safety_check": {
        "name": "Fire safety check",
        "description": "Alarms, routes and equipment. Evidence, not a legal opinion.",
        "items": {
          "0": {
            "label": "Smoke alarms present and sounding"
          },
          "1": {
            "label": "Carbon monoxide alarm present and sounding"
          },
          "2": {
            "label": "Escape routes clear"
          },
          "3": {
            "label": "Fire doors close fully"
          },
          "4": {
            "label": "Extinguishers in date"
          },
          "5": {
            "label": "Emergency lighting working"
          }
        }
      },
      "maintenance_walkthrough": {
        "name": "General maintenance walkthrough",
        "description": "The routine look round that catches things while they are small.",
        "items": {
          "0": {
            "label": "Plumbing and visible leaks"
          },
          "1": {
            "label": "Heating system condition"
          },
          "2": {
            "label": "Electrics and visible wiring"
          },
          "3": {
            "label": "Doors, locks and security"
          },
          "4": {
            "label": "Grounds and drainage"
          }
        }
      }
    },
    "maintenance": {
      "boiler_annual_service": {
        "title": "Annual boiler service",
        "description": "Service the boiler and keep the gas safety record current."
      },
      "fire_safety_quarterly": {
        "title": "Quarterly fire safety check",
        "description": "Alarms, escape routes and equipment."
      }
    },
    "compliance": {
      "gas_safety": {
        "label": "Gas safety record"
      },
      "eicr": {
        "label": "Electrical installation condition report (EICR)"
      },
      "fire_safety": {
        "label": "Fire safety evidence, including smoke and CO alarms"
      }
    }
  },
  "fleet": {
    "assetTypes": {
      "0": "Car",
      "1": "Van",
      "2": "Truck",
      "3": "Trailer"
    },
    "sample": {
      "name": "Sample van",
      "description": "An example vehicle so you can try a daily check before adding your own."
    },
    "templates": {
      "daily_vehicle_check": {
        "name": "Daily vehicle check",
        "description": "The walk-round before the vehicle moves.",
        "items": {
          "0": {
            "label": "Lights and indicators"
          },
          "1": {
            "label": "Tyres and pressures"
          },
          "2": {
            "label": "Brakes feel normal"
          },
          "3": {
            "label": "Mirrors and glass"
          },
          "4": {
            "label": "Fluid levels"
          },
          "5": {
            "label": "Warning lights on dash",
            "description": "Answer yes if any are lit."
          },
          "6": {
            "label": "Load secure"
          }
        }
      },
      "vehicle_condition": {
        "name": "Vehicle condition",
        "description": "The fuller condition record, bodywork to interior.",
        "groups": {
          "0": {
            "label": "Exterior",
            "guidance": "Walk round the vehicle. Show each side, the lights, the glass and the tyres."
          },
          "1": {
            "label": "Interior",
            "guidance": "Show the seats, dashboard and odometer."
          },
          "2": {
            "label": "Records"
          }
        },
        "items": {
          "0": {
            "label": "Bodywork condition"
          },
          "1": {
            "label": "Tyre tread depth acceptable"
          },
          "2": {
            "label": "Glass and mirrors"
          },
          "3": {
            "label": "Lights intact"
          },
          "4": {
            "label": "Interior condition"
          },
          "5": {
            "label": "Odometer reading"
          },
          "6": {
            "label": "Service history up to date"
          }
        }
      },
      "damage_inspection": {
        "name": "Damage inspection",
        "description": "What happened, where, and what it looks like.",
        "items": {
          "0": {
            "label": "Damage photographed from all sides"
          },
          "1": {
            "label": "Vehicle still roadworthy"
          },
          "2": {
            "label": "Panels and bodywork"
          },
          "3": {
            "label": "Glass and lights intact"
          },
          "4": {
            "label": "Third party involved"
          }
        }
      },
      "handover": {
        "name": "Vehicle handover",
        "description": "Condition and contents at the moment the keys change hands.",
        "items": {
          "0": {
            "label": "Odometer reading recorded"
          },
          "1": {
            "label": "Fuel or charge level recorded"
          },
          "2": {
            "label": "Keys and documents handed over"
          },
          "3": {
            "label": "Existing damage recorded"
          },
          "4": {
            "label": "Cleanliness"
          }
        }
      },
      "tyres": {
        "name": "Tyre check",
        "description": "Tread, pressure and condition, corner by corner.",
        "items": {
          "0": {
            "label": "Front left"
          },
          "1": {
            "label": "Front right"
          },
          "2": {
            "label": "Rear left"
          },
          "3": {
            "label": "Rear right"
          },
          "4": {
            "label": "Spare or repair kit present"
          }
        }
      },
      "service_check": {
        "name": "Service check",
        "description": "What the workshop looked at and what it found.",
        "items": {
          "0": {
            "label": "Odometer reading recorded"
          },
          "1": {
            "label": "Oil and filter changed"
          },
          "2": {
            "label": "Brakes inspected"
          },
          "3": {
            "label": "Suspension and steering"
          },
          "4": {
            "label": "Fault codes read and cleared"
          }
        }
      }
    },
    "maintenance": {
      "service_whichever_first": {
        "title": "Service: 12 months or 10,000 miles",
        "description": "Whichever comes first, measured from the last completed service."
      },
      "service_calendar": {
        "title": "Annual service",
        "description": "Every 12 months from the last completed service."
      },
      "service_mileage": {
        "title": "Service every 10,000 miles",
        "description": "Distance only, measured from the reading at the last service."
      }
    },
    "compliance": {
      "roadworthy": {
        "label": "Roadworthiness test, such as an MOT"
      },
      "insurance": {
        "label": "Motor insurance"
      }
    }
  },
  "equipment": {
    "assetTypes": {
      "0": "Machine",
      "1": "Tool",
      "2": "Lifting equipment",
      "3": "Forklift",
      "4": "Compressor"
    },
    "sample": {
      "name": "Sample machine",
      "description": "An example machine so you can try a pre-use check before adding your own."
    },
    "templates": {
      "pre_use_check": {
        "name": "Pre-use check",
        "description": "The check before the operator starts work.",
        "items": {
          "0": {
            "label": "Guards and safety devices in place"
          },
          "1": {
            "label": "Emergency stop works"
          },
          "2": {
            "label": "No visible damage or leaks"
          },
          "3": {
            "label": "Controls and indicators working"
          },
          "4": {
            "label": "Operating hours recorded"
          }
        }
      },
      "condition_inspection": {
        "name": "Condition inspection",
        "description": "How the machine is holding up.",
        "groups": {
          "0": {
            "label": "Identification",
            "guidance": "Show the identification plate and asset tag."
          },
          "1": {
            "label": "External condition",
            "guidance": "Scan the front, sides and base of the equipment. Include the guards, hoses and connections."
          },
          "2": {
            "label": "Operating data",
            "guidance": "Show the hour meter."
          },
          "3": {
            "label": "Functional check"
          }
        },
        "items": {
          "0": {
            "label": "Serial number"
          },
          "1": {
            "label": "General condition"
          },
          "2": {
            "label": "Visible leakage"
          },
          "3": {
            "label": "Guards present and secure"
          },
          "4": {
            "label": "Electrical cables and connectors"
          },
          "5": {
            "label": "Hydraulics and pneumatics"
          },
          "6": {
            "label": "Labels and markings legible"
          },
          "7": {
            "label": "Operating hours"
          },
          "8": {
            "label": "Wear on moving parts"
          },
          "9": {
            "label": "Starts and runs correctly"
          },
          "10": {
            "label": "No unusual noise or vibration"
          }
        }
      },
      "maintenance_inspection": {
        "name": "Maintenance inspection",
        "description": "The planned service visit and what it found.",
        "items": {
          "0": {
            "label": "Operating hours or cycles recorded"
          },
          "1": {
            "label": "Lubrication done"
          },
          "2": {
            "label": "Filters and consumables replaced"
          },
          "3": {
            "label": "Safety devices retested"
          },
          "4": {
            "label": "Returned to service"
          }
        }
      },
      "calibration_evidence": {
        "name": "Calibration evidence check",
        "description": "Whether the calibration on record is current and traceable.",
        "items": {
          "0": {
            "label": "Calibration certificate on file"
          },
          "1": {
            "label": "Calibration still in date"
          },
          "2": {
            "label": "Calibration label on the equipment"
          },
          "3": {
            "label": "Reference standard traceable"
          }
        }
      }
    },
    "maintenance": {
      "service_operating_hours": {
        "title": "Service every 500 operating hours",
        "description": "Measured from the hours reading at the last completed service.",
        "programmeTitle": "Running-hours programme"
      },
      "service_operating_hours_major": {
        "title": "Major service every 1,000 operating hours",
        "description": "The deeper service, measured on the same hours meter."
      },
      "service_cycles": {
        "title": "Overhaul every 2,000 cycles",
        "description": "Measured from the cycle count at the last completed overhaul."
      }
    },
    "compliance": {
      "lifting": {
        "label": "Thorough examination of lifting equipment"
      },
      "electrical": {
        "label": "Electrical safety evidence, such as a PAT record"
      }
    }
  },
  "facilities": {
    "assetTypes": {
      "0": "Building",
      "1": "HVAC",
      "2": "Pump",
      "3": "Generator",
      "4": "Fire system",
      "5": "Electrical distribution"
    },
    "sample": {
      "name": "Sample building",
      "description": "An example building so you can try an inspection before adding your own."
    },
    "templates": {
      "planned_maintenance": {
        "name": "Planned maintenance",
        "description": "The scheduled visit to a piece of plant.",
        "items": {
          "0": {
            "label": "Running hours recorded"
          },
          "1": {
            "label": "Filters and belts"
          },
          "2": {
            "label": "Leaks, noise or vibration"
          },
          "3": {
            "label": "Controls and set points correct"
          },
          "4": {
            "label": "Isolation and safety devices tested"
          }
        }
      },
      "condition_inspection": {
        "name": "Condition inspection",
        "description": "How the building and its plant are holding up.",
        "items": {
          "0": {
            "label": "Building fabric"
          },
          "1": {
            "label": "Roof and drainage"
          },
          "2": {
            "label": "Mechanical plant"
          },
          "3": {
            "label": "Electrical distribution"
          },
          "4": {
            "label": "Common areas"
          }
        }
      },
      "safety_inspection": {
        "name": "Safety inspection",
        "description": "The things that have to be right before anyone is in the building.",
        "items": {
          "0": {
            "label": "Fire alarm panel clear"
          },
          "1": {
            "label": "Escape routes and final exits clear"
          },
          "2": {
            "label": "Emergency lighting working"
          },
          "3": {
            "label": "Extinguishers in date and in place"
          },
          "4": {
            "label": "Signage present and legible"
          }
        }
      },
      "plant_room_check": {
        "name": "Plant room check",
        "description": "The routine look round the plant room.",
        "items": {
          "0": {
            "label": "Plant room secure and clear"
          },
          "1": {
            "label": "No leaks or standing water"
          },
          "2": {
            "label": "Pressures and temperatures in range"
          },
          "3": {
            "label": "Alarms and indicators normal"
          },
          "4": {
            "label": "Ventilation unobstructed"
          }
        }
      },
      "energy_walkround": {
        "name": "Energy and environment walk-round",
        "description": "A look round a building for wasted energy and water, and whether the meters were read.",
        "items": {
          "0": {
            "label": "Meters read this month"
          },
          "1": {
            "label": "Lights off in empty areas"
          },
          "2": {
            "label": "Heating and cooling set to the agreed temperatures"
          },
          "3": {
            "label": "No heating and cooling running at the same time"
          },
          "4": {
            "label": "Doors and windows closed where heating or cooling is on"
          },
          "5": {
            "label": "No dripping taps or running toilets"
          },
          "6": {
            "label": "Equipment switched off out of hours"
          },
          "7": {
            "label": "Energy certificate displayed where required"
          }
        }
      },
      "fgas_leak_check": {
        "name": "F-gas leak check",
        "description": "The periodic leak check of a system holding fluorinated refrigerant, by a certified engineer.",
        "items": {
          "0": {
            "label": "Engineer F-gas certified"
          },
          "1": {
            "label": "Joints, valves and seals checked for leaks"
          },
          "2": {
            "label": "Leak detection system working (where fitted)"
          },
          "3": {
            "label": "No signs of oil around joints"
          },
          "4": {
            "label": "Refrigerant added (record the kg on the asset)"
          },
          "5": {
            "label": "Leak found"
          },
          "6": {
            "label": "Equipment label shows refrigerant type and charge"
          }
        }
      }
    },
    "maintenance": {
      "ppm_quarterly": {
        "title": "Quarterly planned maintenance",
        "description": "Every 3 months from the last completed visit."
      },
      "generator_hours": {
        "title": "Generator service every 250 running hours",
        "description": "Measured from the hours reading at the last completed service."
      }
    },
    "compliance": {
      "energy_performance": {
        "label": "Energy performance certificate (EPC)"
      },
      "water_hygiene": {
        "label": "Water hygiene evidence, such as a legionella risk assessment"
      },
      "fire_safety": {
        "label": "Fire safety evidence"
      },
      "lifting": {
        "label": "Thorough examination of lifting equipment"
      },
      "electrical": {
        "label": "Electrical installation condition report (EICR)"
      }
    }
  }
};
